var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.vacancyPage)?_c('div',{attrs:{"id":"project-edit-tab-job"}},_vm._l((_vm.vacancyPage.results),function(vacancy){return _c('div',{key:vacancy.id,staticClass:"job-title"},[_c('router-link',{attrs:{"to":{
        name: 'project.edit.sub.job',
        params: { page: 'jobs', jobid: vacancy.id }
      }}},[_vm._v(" "+_vm._s(vacancy.number)+" - "+_vm._s(vacancy.title)+" ")])],1)}),0):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }